import { FormEvent } from "react"
import { BillingAddressForm, ItemAddressWhisper } from "types/address"

export default function BillingAddress(props: {
  onDataChange: (data: BillingAddressForm) => void
  shownData: BillingAddressForm

  onWhisperSelected: (address: ItemAddressWhisper) => void
  whisperAddress: ItemAddressWhisper[]
  showWhisper: boolean

  checkBillinggAsDelivery: boolean
  setCheckBillingAsDelivery: (value: boolean) => void
}) {
  const handleFormChange = (e: FormEvent<HTMLFormElement>) => {
    props.onDataChange({
      company: e.currentTarget.company.value,
      branch: e.currentTarget.branch.value,
      address: e.currentTarget.address.value,
      phone: e.currentTarget.phone.value,
      email: e.currentTarget.email.value,
      ico: e.currentTarget.ico.value,
      dic: e.currentTarget.dic.value,
    })
  }

  const handleInputChange = (e: FormEvent<HTMLInputElement>) => {
    const { name, value } = e.currentTarget
    props.onDataChange({
      ...props.shownData,
      [name]: value,
    })
  }

  return (
    <div className="flex flex-col items-center justify-center max-w-[20rem] mb-5">
      <h2 className="pb-5 text-xl font-semibold underline">
        Fakturační adresa
      </h2>
      <div className="flex flex-col w-full h-full">
        <form
          name="billingForm"
          className="grid flex-col w-full h-full grid-cols-2 border-[#e5e7eb] gap-3 text-center"
        >
          <input
            type="text"
            name="company"
            placeholder="Společnost"
            className="p-2 border rounded-lg"
            required
            value={props.shownData.company}
            onChange={(e) => handleInputChange(e)}
          />
          <input
            type="text"
            name="branch"
            placeholder="Pobobčka"
            className="p-2 border rounded-lg"
            value={props.shownData.branch}
            onChange={(e) => handleInputChange(e)}
          />

          <div className="relative w-full col-span-2">
            <input
              type="text"
              name="address"
              placeholder="Adresa"
              className={`w-full p-2 border rounded-t-lg ${
                props.showWhisper && props.whisperAddress.length > 0
                  ? ""
                  : "rounded-b-lg"
              }`}
              value={props.shownData.address}
              required
              onChange={(e) => handleInputChange(e)}
            />

            <ul
              className={`absolute w-full bg-white border rounded-b-lg shadow-lg ${
                props.showWhisper && props.whisperAddress.length > 0
                  ? "block"
                  : "hidden"
              }`}
            >
              {props.whisperAddress.map((item, index) => (
                <li
                  key={index}
                  className="p-2 border-b hover:bg-gray-50 hover:font-medium hover:cursor-pointer"
                  onClick={() => {
                    props.onWhisperSelected(item)
                  }}
                >
                  {item.name},{" "}
                  {
                    item.regionalStructure.find(
                      (i) => i.type == "regional.municipality"
                    )?.name
                  }{" "}
                  {item.zip}
                </li>
              ))}
            </ul>
          </div>

          <input
            type="tel"
            name="phone"
            placeholder="Telefon"
            className="col-span-2 p-2 border rounded-lg"
            value={props.shownData.phone}
            required
            onChange={(e) => handleInputChange(e)}
          />
          <input
            type="email"
            name="email"
            placeholder="E-mail"
            className="col-span-2 p-2 border rounded-lg"
            value={props.shownData.email}
            onChange={(e) => handleInputChange(e)}
            required
          />

          <input
            type="text"
            name="ico"
            placeholder="IČO"
            className="col-span-2 p-2 border rounded-lg"
            value={props.shownData.ico}
            onChange={(e) => handleInputChange(e)}
            required
          />

          <input
            type="text"
            name="dic"
            placeholder="DIČ"
            className="col-span-2 p-2 border rounded-lg"
            value={props.shownData.dic}
            onChange={(e) => handleInputChange(e)}
            required
          />
        </form>
        <div className="flex flex-row items-center justify-center w-full mt-5 gap-x-2">
          <input
            type="checkbox"
            name="billingAsDelivery"
            checked={props.checkBillinggAsDelivery}
            onChange={(e) =>
              props.setCheckBillingAsDelivery(e.currentTarget.checked)
            }
          />
          <h2 className="text-base font-medium text-center">
            Doručovací je stejná jako fakturační
          </h2>
        </div>
      </div>
    </div>
  )
}
